import { render, staticRenderFns } from "./ExtendedService.vue?vue&type=template&id=e5416f82&scoped=true"
import script from "./ExtendedService.vue?vue&type=script&lang=js"
export * from "./ExtendedService.vue?vue&type=script&lang=js"
import style0 from "./ExtendedService.vue?vue&type=style&index=0&id=e5416f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5416f82",
  null
  
)

export default component.exports